import React, { useState } from "react";
import bcrypt from "bcryptjs"; // browser-friendly version of bcrypt

const PasswordHash = () => {
  const [password, setPassword] = useState("");
  const [hash, setHash] = useState("");

  const generateHash = async () => {
    const saltRounds = 10;
    const generatedHash = await bcrypt.hash(password, saltRounds);
    setHash(generatedHash);
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "500px", margin: "auto" }}>
      <h2>Password Hasher</h2>
      <input
        type="password"
        value={password}
        placeholder="Enter password"
        onChange={(e) => setPassword(e.target.value)}
        style={{ width: "100%", padding: "0.5rem", marginBottom: "1rem" }}
      />
      <button onClick={generateHash} style={{ padding: "0.5rem 1rem" }}>
        Generate Hash
      </button>

      {hash && (
        <div style={{ marginTop: "1rem" }}>
          <strong>Hash:</strong>
          <p style={{ wordBreak: "break-all" }}>{hash}</p>
        </div>
      )}
    </div>
  );
};

export default PasswordHash;
